// Mapa de sentimento PT (positivo/neutro/negativo) → metadados de UI.
// Cores derivadas dos tokens do AAWZ DS (CSS variables expostas em :root via
// src/design/_vars.sass). NÃO usar hex inline em componentes — referenciar via
// SENTIMENT_META[...].cssVar para manter aderência ao design-system.
//
// positivo → --success (#398E4A, verde)
// neutro   → --await (#e0c200, âmbar)
// negativo → --danger (#EB5757, rosa/vermelho)

export const SENTIMENT_META = {
  positivo: {
    label: 'Positivo',
    icon: 'mdi-emoticon',
    cssVar: 'var(--success)',
    accent: 'success',
  },
  neutro: {
    label: 'Neutro',
    icon: 'mdi-emoticon-neutral',
    cssVar: 'var(--await)',
    // `await` e não `warning-new`: $warning-new existe só como variável SASS,
    // fora dos mapas que o :root percorre (src/design/_vars.sass), então
    // var(--warning-new) resolve vazio e invalida o color-mix que usa a cor.
    accent: 'await',
  },
  negativo: {
    label: 'Negativo',
    icon: 'mdi-emoticon-sad',
    cssVar: 'var(--danger)',
    accent: 'danger',
  },
}

const FALLBACK_META = {
  label: 'N/A',
  icon: 'mdi-help-circle',
  cssVar: 'var(--gray-5)',
  accent: 'gray-5',
}

export const sentimentMeta = (sentimento) => {
  return (sentimento && SENTIMENT_META[sentimento]) || FALLBACK_META
}

// Mapeamento PT↔EN (RF-13) caso o backend devolva rótulos em inglês.
export const SENTIMENT_EN_TO_PT = {
  positive: 'positivo',
  neutral: 'neutro',
  negative: 'negativo',
}

export const normalizeSentimento = (value) => {
  if (!value) return null
  if (SENTIMENT_META[value]) return value
  return SENTIMENT_EN_TO_PT[value] || null
}
